import APIclient from "API/Client";
import { IOriginalBillData } from "Views/Bills/ImportBillFromXero/type";

export const mapXeroBillsToSpenmo = (bills: IOriginalBillData[]) => {
  return APIclient.postData("/ms/b2b-accounting/v1/xero/bills/map", { bills });
};
